<template>
  <div v-if="guide" class="an-guide">
    <div class="an-guide__head">
      <i class="fa fa-question-circle an-guide__icon"></i>
      <span class="an-guide__question">{{ guide.question }}</span>
      <button type="button" class="an-guide__toggle" @click="toggle">
        {{ open ? 'Скрыть' : 'Как читать' }} <i class="fa" :class="open ? 'fa-angle-up' : 'fa-angle-down'"></i>
      </button>
    </div>
    <div v-if="open" class="an-guide__body">
      <ul class="an-guide__list">
        <li v-for="(line, i) in guide.read" :key="i">{{ line }}</li>
      </ul>
      <p class="an-guide__line"><b>Когда беспокоиться:</b> {{ guide.worry }}</p>
      <p class="an-guide__line"><b>Что делать:</b> {{ guide.action }}</p>
    </div>
  </div>
</template>

<script>
import {TAB_GUIDE} from "@/common/rumGuide";

const STORAGE_KEY = 'analytics_guide_closed'

function readClosed() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

/**
 * Вопрос вкладки виден всегда, пояснение раскрыто, пока его не свернули:
 * новичку оно нужно, а тот, кто уже разобрался, свернёт один раз.
 */
export default {
  name: "RumGuide",
  props: {
    tab: {type: String, required: true},
  },
  data() {
    return {closed: readClosed()}
  },
  computed: {
    guide() {
      return TAB_GUIDE[this.tab] || null
    },
    open() {
      return !this.closed.includes(this.tab)
    },
  },
  methods: {
    toggle() {
      this.closed = this.open ? [...this.closed, this.tab] : this.closed.filter(t => t !== this.tab)
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.closed))
      } catch (e) {
        // приватный режим: свёрнутость просто не запомнится
      }
    },
  },
}
</script>
